import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { } from "@angular/material/";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { OrganisationDto } from '@aoe/client';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { FormComponent } from 'src/app/core/class/Form';
import { selectOrganisation } from 'src/app/core/store/organisation/organisation.selector';

@Component({
  selector: 'aoe-select-organisation',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MatDialogModule, MatFormFieldModule, MatSelectModule, MatButtonModule],
  templateUrl: './select-organisation.component.html',
  styleUrl: './select-organisation.component.scss'
})
export class SelectOrganisationComponent extends FormComponent {

  organisations!: OrganisationDto[];

  constructor(
    private readonly store: Store,
    private readonly fb: FormBuilder,
    private readonly matDailog: MatDialogRef<SelectOrganisationComponent>
  ) {
    super(
      fb.group({
        id: new FormControl(null, [Validators.required])
      })
    )
    store.select(selectOrganisation).pipe(
      map(r =>
        [...r].sort((a, b) => a.name.localeCompare(b.name))
      )
    ).subscribe(res => {
      this.organisations = res;
      if (this.organisations.length > 0)
        this.formGroup.controls['id'].setValue(this.organisations[0].id);
    });
  }

  get hasOrganisation(): boolean {
    return this.organisations.length > 0;
  }

  submit() {
    this.matDailog.close(this.formGroup.controls['id'].value);
  }

}
